import { NgModule } from '@angular/core';
import { PageNotFoundComponent } from './page-not-found.component';

@NgModule({
  declarations: [ PageNotFoundComponent ],
  exports: [ PageNotFoundComponent ]
})
export class PageNotFoundModule { }
